module.exports = __webpack_public_path__ + "assets/img/steam-yuyue-e320f11e.png";